import CenterMenuLeftLogo from '../Styles/CenterMenuLeftLogo.module.css';
import CenterMenuCenterLogo from '../Styles/CenterMenuCenterLogo.module.css';
import LeftMenuTopLogo from '../Styles/LeftMenuTopLogo.module.css';
import NoMenuLeftLogo from '../Styles/NoMenuLeftLogo.module.css';
import NoMenuCenterLogo from '../Styles/NoMenuCenterLogo.module.css';
import SplitMenuCenterLogo from '../Styles/SplitMenuCenterLogo.module.css';

export default {
  CenterMenuLeftLogo,
  CenterMenuCenterLogo,
  LeftMenuTopLogo,
  NoMenuLeftLogo,
  NoMenuCenterLogo,
  SplitMenuCenterLogo,
};
